import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { IconButton } from '@mui/material'
import {
  dateFromString,
  dateToMonth,
  dateToString,
  getStartOfMonth,
  isSameMonth,
  monthToString
} from '../../utils/date'
import { getEventos } from '../../utils/api/eventos'
import { useNotification } from '../../context/NotificationManager/NotificationManager'
import Calendar from '../../components/Calendar/Calendar'
import ModalEventoCalendario from '../../modals/ModalEventoCalendario/ModalEventoCalendario'
import css from './Calendario.module.css'

const EventoCalendario = ({ evento, onClick, dimmed }) => {
  const handleClick = () => {
    if (!dimmed && onClick) onClick(evento)
  }

  return (
    <div
      className={css.evento}
      data-status={dimmed ? 'dimmed' : 'normal'}
      data-type={evento.tipo}
      onClick={handleClick}
    >
      <i className='material-icons'>
        {evento.tipo === 'COMUNICADO' && 'campaign'}
        {evento.tipo === 'AVISO' && 'info'}
        {evento.tipo === 'NOTIFICACION' && 'notifications'}
        {evento.tipo === 'RECORDATORIO' && 'alarm'}
        {evento.tipo === 'ALERTA' && 'warning'}
      </i>
      <p className={css.eventoTitulo}>{evento.titulo}</p>
    </div>
  )
}

const Calendario = () => {
  const notification = useNotification()
  const [mes, setMes] = useState(getStartOfMonth())

  const [eventoSeleccionado, setEventoSeleccionado] = useState(null)

  const handleMonthChange = offset => {
    const newMes = new Date(mes)
    newMes.setMonth(newMes.getMonth() + offset)
    setMes(newMes)
  }

  const { data: eventos = [] } = useQuery({
    queryKey: ['interno', 'eventos-calendario', 'list', monthToString(mes)],
    queryFn: () =>
      getEventos(monthToString(mes))
        .then(datos =>
          datos.map(evento => ({
            ...evento,
            fecha: dateToString(evento.fecha)
          }))
        )
        .catch(err => {
          notification.error({
            title: 'Error al recuperar los eventos',
            content: err
          })
          return []
        })
  })

  const eventosCalendario = Object.entries(
    eventos
      .map(evento => ({
        fecha: evento.fecha,
        evento: evento
      }))
      .reduce(
        (acc, { fecha, evento }) => ({
          ...acc,
          [fecha]: [...(acc[fecha] || []), evento]
        }),
        {}
      )
  ).reduce(
    (acc, [fecha, eventos]) => ({
      ...acc,
      [fecha]: (
        <>
          {eventos.map(evento => (
            <EventoCalendario
              key={evento.id}
              evento={evento}
              dimmed={!isSameMonth(dateFromString(evento.fecha), mes)}
              onClick={setEventoSeleccionado}
            />
          ))}
        </>
      )
    }),
    {}
  )

  return (
    <div className={css.main}>
      <div className={css.calendar}>
        <div className={css.monthSelection}>
          <IconButton
            className={css.monthIcon}
            size='small'
            onClick={() => handleMonthChange(-1)}
          >
            <i className='material-icons'>arrow_back</i>
          </IconButton>
          <p className={css.calendarMonth}>{dateToMonth(mes)}</p>
          <IconButton
            className={css.monthIcon}
            size='small'
            onClick={() => handleMonthChange(+1)}
          >
            <i className='material-icons'>arrow_forward</i>
          </IconButton>
        </div>
        <Calendar
          month={monthToString(mes)}
          placeholder='Sin eventos'
          events={eventosCalendario}
        />
        <ModalEventoCalendario
          open={!!eventoSeleccionado}
          evento={eventoSeleccionado}
          onClose={() => setEventoSeleccionado(null)}
        />
      </div>
    </div>
  )
}

export default Calendario
